import { DonutChart, Text } from '@cinesend/ui-kit'
import { useQuery } from '@tanstack/react-query'
import DashboardWidget from '../widget'

const progressTone = (percentage) => {
  if (percentage >= 100) return 'success'
  if (percentage >= 61) return 'warning'
  if (percentage >= 41) return 'orange'
  return 'error'
}

const ProgressWidget = ({ cycleID, ...widgetProps }) => {
  const { data: percentage, isLoading, error, refetch } = useQuery([`cycles/`, cycleID, `/get-progress`])

  return (
    <DashboardWidget title='Progress' isLoading={isLoading} error={error} onRetry={refetch} {...widgetProps}>
      <div className='flex h-full min-h-0 flex-1 items-center justify-center'>
        <div className='grid w-full grid-cols-[repeat(auto-fit,minmax(6.5rem,1fr))] place-content-center justify-items-center gap-3'>
          {percentage?.data?.map((item, index) => {
            const value = Math.round(Number(item.percentage) || 0)
            return (
              <div className='flex flex-col items-center gap-2' key={`${item.name}-${index}`}>
                <DonutChart
                  label={`${item.name} progress`}
                  size='sm'
                  centerLabel={`${value}%`}
                  segments={[
                    { label: item.name, value, tone: progressTone(value) },
                    { label: 'Remaining', value: Math.max(0, 100 - value), tone: 'muted' },
                  ]}
                  showLegend={false}
                />
                <Text as='p' variant='sm' tone='secondary' className='text-center'>
                  {item.name}
                </Text>
              </div>
            )
          })}
        </div>
      </div>
    </DashboardWidget>
  )
}

export default ProgressWidget
